import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

export type SnowplowPayload = Record<string, unknown>;

export const snowplowEvent = (
  { schema, version = '1-0-0', ...payload }: { [key: string]: unknown; schema: string; version?: string },
) => {
  const newData = {
    category: 'handshake_dealer',
    ...payload,
  };

  setTimeout(() => {
    trackSelfDescribingEvent({
      event: {
        schema: `iglu:uk.co.motorway/${schema}/jsonschema/${version}`,
        data: newData,
      },
    });
  }, 0);
};

export const snowplowClick = (payload: SnowplowPayload) => {
  snowplowEvent({
    ...payload,
    schema: 'click',
    version: '2-0-0',
  });
};

export const snowplowCtaClick = (payload: SnowplowPayload) => {
  snowplowEvent({
    ...payload,
    schema: 'cta_clicked',
    version: '5-0-1',
  });
};
